<ng-template #tolTemplate>
    {{'input-mask-tooltip-help-1' | translate }}
    <br>
    <br> {{'input-mask-tooltip-help-2' | translate }}
    <br> {{'input-mask-tooltip-help-3' | translate }}
    <br> {{'input-mask-tooltip-help-4' | translate }}
    <br>
    <br> {{'input-mask-tooltip-help-5' | translate }}
</ng-template>
<div class="form-group">
    <label class="input-label">{{'Input mask' | translate}}: <i style="cursor: help" class="fal fa-lightbulb" [tooltip]="tolTemplate"
                                          aria-hidden="true"></i></label>
    <input type="text"
           name="fieldOptions.inputMask"
           value="{{fieldOptions.inputMask}}"
           [(ngModel)]="fieldOptions.inputMask"
           (ngModelChange)="dataChangedEvent($event)"
           class="form-control">
</div>